<template>
	<div class="default-input default-input--period" :class="{error : errors.length, disabled : disabled, 'default-input--bg' : inputGray, 'default-input--required' : required }">
		<span class="default-input__label" v-if="label">{{ label }}</span>
		<div class="default-input__wrapper default-input__wrapper--3">
			<div class="default-input__wrapper-el">
				<span class="default-input__span">от</span>
				<div class="default-input__input">
					<input type="number" v-model="value[0]" :required="required" :placeholder="placeholder" :disabled="disabled">
				</div>
			</div>
			<div class="default-input__wrapper-el">
				<span class="default-input__span">до</span>
				<div class="default-input__input">
					<input type="number" v-model="value[1]" :required="required" :placeholder="placeholder" :disabled="disabled">
				</div>
			</div>
			<div class="default-input__wrapper-el">
				<div class="default-select" :class="{'default-select--bg' : inputGray }">
					<slot name="select"></slot>
				</div>
			</div>
		</div>
		<ul v-if="errors.length" class="default-input__errors">
			<li v-for="(error,index) in errors" :key="index">{{ error.$message }}</li>
		</ul>
	</div>
</template>

<script>

export default {
	name: "InputPeriodVolume",
	emits: ["update:modelValue"],
	props: {
		modelValue: {
			type: Array,
			// validator(value) {
			// 	return value.length === 2
			// },
			default: () => {}
		},
		disabled: {
			type: Boolean,
			default: false
		},
		required: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: "",
		},
		label: {
			type: String,
			default: ''
		},
		errors: {
			type: Array,
			default: () => []
		},
		inputGray: {
			type: Boolean,
			default: false
		},
	},
	computed: {
		value: {
			get() {
				return this.modelValue
			},
			set(value) {
				this.$emit('update:modelValue', value)
			}
		},
	},
}
</script>


